import { useRouter } from 'next/router'
import Link from 'next/link'
import useT from '@hooks/useTranslation'

import styles from 'styles/Breadcrumbs.module.css'

const SKIP_ALLWAYS = ['[shortid]', '[lang]', 'lokalizacja', 'oferta']

const Breadcrumbs = ({ skip = [], locationPosition }) => {
    const router = useRouter()
    const chunks = pathChunks(router, skip, locationPosition)
    const fullpath = router.asPath // includes query

    return (
        <CrumbsWrapper>
            <Crumbs chunks={chunks} fullpath={fullpath} />
        </CrumbsWrapper>
    )
}

function CrumbsWrapper ({ children }) {
    return (
        <ol className={styles.wrapper} itemScope itemType="http://schema.org/BreadCrumbList">
            { children }
        </ol>
    )
}

function Crumbs ({ chunks, fullpath }) {
    const usableChunks = [{ name: '/', path: '/'}, ...chunks]
        .filter(chunk => !chunk.skip)

    const usableCount = usableChunks.length - 1

    return usableChunks
        .reduce((acc, chunk, i) => {
            const {name, path} = chunk
            acc.push(
                <Crumb
                    key={path}
                    chunk={name}
                    path={i === usableCount
                        ? fullpath
                        : path}
                    pos={i}
                />)

            return acc
        }, [])
}

function Crumb ({ chunk, path, pos }) {
    return (
        <li key={path} itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem" className={styles.crumb}>
            <Link href={path}>
                <a itemProp="item">
                    <span itemProp="name">{unslugify(chunk)}</span>
                </a>
            </Link>
            <meta itemProp="position" content={pos} />
        </li>
    )
}

function pathChunks ({ pathname, query }, skip, locationPosition) {
    const currentPath = []
    return pathname
        .slice(1)
        .split('/')
        .map((chunk, i) => {
            const name = chunk.startsWith('[') && chunk.endsWith(']')
                ? query[chunk.slice(1, -1)]
                : chunk

            let pathPrefix = ''
            if (locationPosition === i) {
                pathPrefix = 'lokalizacja/'
            }

            currentPath.push(`${pathPrefix}${name}`)

            return {
                name,
                path: `/${currentPath.join('/')}`,
                skip: skip.includes(chunk)
                    || SKIP_ALLWAYS.includes(chunk)
                    || !Boolean(chunk),
            }
        })
}

function unslugify (string) {
    if (string == null) return ''
    return string === '/'
        ? useT('Darmowe ogłoszenia')
        : string.replace(/-/g, ' ')
}

export default Breadcrumbs